import { Component, Inject, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-ktostamm-kunde-field-ok-data-view',
  imports: [],
  templateUrl: './ktostamm-kunde.list-view.html',
  styleUrls: ['./ktostamm-kunde.list-view.css'],
})
export class KtostammKundeListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
